
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, ArrowLeft, Home } from 'lucide-react';
import { useAuthPayment } from '@/contexts/AuthPaymentContext';
import { toast } from '@/components/ui/sonner';

/**
 * Простая страница успешной авторизации платежа
 * Не выполняет никаких автоматических действий с подписками
 */
export default function PaymentAuthSuccess() {
  const [countdown, setCountdown] = useState(5); // Счетчик для автоматического перенаправления
  const navigate = useNavigate();
  const { refreshAuthPayment } = useAuthPayment();

  // Автоматически перенаправляем пользователя на страницу курьера 
  useEffect(() => {
    // Обновляем статус авторизационных платежей в контексте
    refreshAuthPayment().catch(error => {
      console.error('Ошибка при обновлении статуса авторизационных платежей:', error);
    });

    // Показываем уведомление об успешной авторизации
    toast.success('Карта успешно авторизована', {
      description: 'Средства не были списаны с карты',
      duration: 5000
    });

    // Запускаем таймер для автоматического перенаправления
    let timer: NodeJS.Timeout | null = null;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      // Перенаправляем на страницу курьера
      window.location.href = '/courier';
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [countdown, refreshAuthPayment]);

  // Обработчик для возврата на главную страницу курьера
  const handleBackToDashboard = () => {
    window.location.href = '/courier';
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-green-600 flex items-center justify-center gap-2">
            <CheckCircle className="h-6 w-6" />
            Успешная авторизация
          </CardTitle>
          <CardDescription>Ваш платеж успешно обработан</CardDescription>
        </CardHeader>
        <CardContent className="text-center py-6">
          <p>Карта авторизована успешно. Теперь вы можете пользоваться сервисом.</p>
          <p className="mt-4 text-muted-foreground">
            Вы будете автоматически перенаправлены через <span className="font-bold">{countdown}</span> сек.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col gap-2">
          <Button 
            onClick={handleBackToDashboard} 
            className="w-full flex items-center justify-center gap-2"
          >
            <Home className="h-4 w-4" />
            На главную
          </Button>
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="w-full flex items-center justify-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Вернуться назад
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
